export const hcData = {
  heroPanel: {
    backgroundImageMobile:
      'https://cdn4.careguide.com/assets/cca/cca-hero-bkgd-mobile-67322c3c915c974e6e0b7f9dbc7d523d69ec4f901dca0b889ae6c3d2059a5ff2.jpg',

    backgroundImageDesktop:
      'https://cdn4.careguide.com/assets/cca/cca-hero-bkgd-181aed81cb2bf0b56b93b727a490776df00b786655e26790cb702edc6c0b545c.jpg',
    header: 'Your Leading Resource to Find Quality Child Care Staff',
    body:
      'Child Care Advantage is the only online service devoted entirely to helping child care centres connect with qualified staff.',
    buttonCta: 'Post a Job',
    buttonLink: '/get-started/user-type?user_type=SEEKER',
    jobSeeker: 'Are you a job seeker? Click',
    jobSeekerLinkText: 'here.',
    jobSeekerLink: '/get-started/user-type?user_type=PROVIDER',
  },
  aboutUs: {
    header: 'About Us',
    bodyCopy:
      'Child Care Advantage has been supporting child care centres, preschools, daycares, before and after school programs, kids camps and more to meet their staffing needs for over 10 years. If you are looking for qualified staff or are an Early Childhood Educator, Assistant, Supervisor, Montessori Teacher, Cook or Bus Driver looking for a position — we are your child care focused connection! ',
  },
  features: {
    header: 'Features',
    subHeader: 'Your Connection to Thousands of Jobseekers and Child Care Organizations',
    waveImage:
      'https://cdn4.careguide.com/assets/cca/cca-icon-wave-5b45c9aa800f8cbdfa1c14b36f72fd76a24c6b8df11042312b25a1def5747e36.svg',
    cards: [
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-expert-advice-3b4fd7c1f61018038f3bb30e903dc700c3b77b036e182e79a65783770c7e3f82.svg',
        header: 'Expert Advice',
        copy: 'A personal review of your job listing and expert recommendations.',
      },
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-service-support-2edbd85ea8bd484f23f9efe7760d32fb9d10b1498ee06adf4b67c099eb11e171.svg',
        header: 'Customer Service Support',
        copy: 'Rapid response phone and email support.',
      },
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-3page-profile-65b3a8c8cd888bfef0703a66f9820eccaedb3e7ba57496bfb9126921bd035a2d.svg',
        header: '3-Page Profile',
        copy: 'Detailed 3-page profile and resume available for each job seeker.',
      },
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-quick-response-f32130cda95a87e01cbf33e6b078d50e031eb358119d7f78c306071005e04e40.svg',
        header: 'Quick Response',
        copy:
          'Your job posting is sent directly to jobseekers by email, guaranteeing maximum exposure.',
      },
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-controlled-flexibility-08ef053da3dfe22f89821d8ac4686da1b245014dbf2208791c2ce245bafebcba.svg',
        header: 'Controlled Flexibility',
        copy: 'You control the entire screening & hiring process.',
      },
      {
        image:
          'https://cdn4.careguide.com/assets/cca/cca-icon-qualified-candidates-749f0b1939cffd39a39c193d01c698bd5b47bf57e83b3de57c1d890eeff8a1d5.svg',
        header: 'Qualified Candidates',
        copy: 'Local ECE’s, Assistants, Supervisors, Montessori Teachers and more!',
      },
    ],
  },
  easyEffectiveAffordable: {
    imageSrc:
      'https://cdn4.careguide.com/assets/cca/cca-tagline-412371fab8424abe3b9d785ae3c507e703b68223813b13d99bb8e68ba0d0c82a.svg',
    bodyCopy:
      'For over 10 years we’ve helped thousands of child care organizations find reliable, qualified educators and support staff.',
    innerDivColor: '#e9b677',
    outerDivColor: '#e65c83',
  },
  pricing: {
    header: 'PRICING',
    subHeader: 'Dramatically More Affordable Than Traditional Recruitment Options',
    bodyText:
      'You choose the subscription based on your hiring needs. Once your job is active potential candidates will contact you through the internal messaging system. Or you can search for qualified educators in your area and reach out to them. We also include a personal review of your job listings, and both internal and external recruiting to your job.',
    buttonCTA: 'Learn More About Our Pricing',
    buttonLink: '/pricing',
    tryItCta: 'Try it Now',
    tryItLink: '/get-started/user-type?user_type=SEEKER',
    image:
      'https://cdn4.careguide.com/assets/cca/cca-pricing-img-5412f89ec89b7268d3d60755e8ec926b97aded3dac3e4ca88c1129b70c2be438.jpg',
  },
  reviews: {
    header: 'REVIEWS',
    subHeader: 'Thousands of Child Care Organizations Trust Us',
    bodyText:
      '"The experience that I had using Child Care Advantage has been fantastic. Not only have I filled the positions I had available, I have found candidates who are even more qualified then I had hoped for."',
    author: 'Mimma Dv',
    location: 'Oxford Child Development Centre',
    backgroundImage:
      'https://cdn4.careguide.com/assets/cca/cca-review-bkgd-e7480ff589aa089550c467600501aeb0b385c9c7a5296c6c733a4050c938dd21.svg',
  },
}
